"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useOnce(effect) {
    return react_1.useEffect(effect, []);
}
exports.useOnce = useOnce;
function useOnceAsync(effect) {
    return useOnce(function () {
        effect();
    });
}
exports.useOnceAsync = useOnceAsync;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLW9uY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlLW9uY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBZ0Q7QUFJaEQsU0FBZ0IsT0FBTyxDQUFDLE1BQXNCO0lBQzFDLE9BQU8saUJBQVMsQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDakMsQ0FBQztBQUZELDBCQUVDO0FBRUQsU0FBZ0IsWUFBWSxDQUFDLE1BQTJCO0lBQ3BELE9BQU8sT0FBTyxDQUFDO1FBQ1gsTUFBTSxFQUFFLENBQUM7SUFDYixDQUFDLENBQUMsQ0FBQztBQUNQLENBQUM7QUFKRCxvQ0FJQyJ9